export default [
    {
        size: {
            height: 60,
            width: 30
        }, 
        position: {
            x: 0,
            y: 180
        }
    },
    {
        size: {
            height: 80,
            width: 30
        }, 
        position: {
            x: 210,
            y: 160
        }
    },
    {
        size: {
            height: 10,
            width: 30
        }, 
        position: {
            x: 320,
            y: 230
        }
    },
    //Ground blocks start here:
    {
        size: {
            height: 40,
            width: 30
        }, 
        position: {
            x: 160,
            y: 0
        }
    },
    {
        size: {
            height: 60,
            width: 30
        }, 
        position: {
            x: 400,
            y: 0
        }
    },
    {
        size: {
            height: 30,
            width: 60
        }, 
        position: {
            x: 570,
            y: 0
        }
    }
]


/** WEBPACK FOOTER **
 ** ./src/data/level3.js
 **/